import React from "react";
import { useNavigate } from "react-router-dom";

function HomeScreen() {
  const navigate = useNavigate();

  const handleButtonClick = (value) => {
    navigate("/data-management", { state: { value } });
  };

  return (
    <div className="flex flex-col p-5">
      <div className="grid grid-cols-2 gap-6 w-full">
        <button
          className="btn btn-primary h-[80px] text-xl font-semibold rounded-2xl flex items-center justify-center"
          onClick={() => handleButtonClick("houseDesign")}
        >
          House Design
        </button>
        <button
          className="btn btn-primary h-[80px] text-xl font-semibold rounded-2xl flex items-center justify-center"
          onClick={() => handleButtonClick("construction")}
        >
          Construction Calculators
        </button>
        <button
          className="btn btn-primary h-[80px] text-xl font-semibold rounded-2xl flex items-center justify-center"
          onClick={() => handleButtonClick("shop")}
        >
          Shop
        </button>
        <button
          className="btn btn-primary h-[80px] text-xl font-semibold rounded-2xl flex items-center justify-center"
          onClick={() => handleButtonClick("projects")}
        >
          Our Projects
        </button>
        {/* <button
          className="btn btn-primary h-[80px] text-xl font-semibold rounded-2xl flex items-center justify-center"
          onClick={() => handleButtonClick("frontElevation")}
        >
          Front Elevation
        </button> */}
        <button
          className="btn btn-primary h-[80px] text-xl font-semibold rounded-2xl flex items-center justify-center"
          onClick={() => handleButtonClick("blog")}
        >
          Blogs
        </button>
        <button
          className="btn btn-primary h-[80px] text-xl font-semibold rounded-2xl flex items-center justify-center"
          onClick={() => handleButtonClick("interiorDesign")}
        >
          Interior Design
        </button>
      </div>
    </div>
  );
}

export default HomeScreen;
